import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, useSeo } from "@/lib/api";
import Breadcrumbs from "@/components/Breadcrumbs";
import { ArrowRight, Calendar } from "lucide-react";

export default function Blog() {
  useSeo("Savings Blog — SharePromos", "Expert guides on how to save money, stack coupons, and shop smarter online. New articles weekly.", {
    keywords: "money saving tips, coupon stacking guide, savings blog, deal hunting, cashback strategies, shopping tips",
  });
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)); }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 md:py-20" data-testid="blog-page">
      <Breadcrumbs items={[{ label: "Blog" }]} />
      <p className="overline mb-4">Money guides</p>
      <h1 className="font-display text-4xl md:text-6xl tracking-tighter uppercase mb-12">The Savings Blog</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {posts.map((p) => (
          <Link key={p.slug} to={`/blog/${p.slug}`}
                data-testid={`blog-card-${p.slug}`}
                className="group border border-slate-200 bg-white hover-lift rounded-sm overflow-hidden">
            {p.cover_image && (
              <div className="aspect-[16/10] bg-slate-100 overflow-hidden">
                <img src={p.cover_image} alt={`Illustration for ${p.title}`} loading="lazy"
                     className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
            )}
            <div className="p-6">
              <p className="overline text-slate-400 mb-3 flex items-center gap-2">
                <Calendar className="w-3 h-3" />
                {new Date(p.published_at).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}
              </p>
              <h2 className="font-display text-xl tracking-tight text-slate-950 group-hover:text-emerald-600 mb-3 leading-snug">
                {p.title}
              </h2>
              <p className="text-sm text-slate-600 leading-relaxed line-clamp-3">{p.excerpt}</p>
              <span className="inline-flex items-center gap-2 text-sm font-medium mt-4">
                Read <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
